/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react-native/no-color-literals */
import React, { useEffect, useMemo, useState } from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';

import SociollaText from '@components/sociolla/SociollaText';
import MoreButton from '@components/navbar/MoreButton';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';
import * as Layout from '@components/screen/Layout';
import Table from '@components/table/Table';
import TableMobile from '@components/table/TableMobile';
import Image from '@components/global/Image';
import Button from '@components/form/Button';
import RenderIf from '@components/global/RenderIf';
import ModalAttachment from './components/ModalAttachment';
import ModalAddEditPeriod from './components/ModalAddEditPeriod';

import { hasNoAccess } from '@global/helpers';
import Colors from '@global/colors';
import { isWeb } from '@global/screens';
import useListScreen from '@/hooks/useListScreen';
import {
  useGetRequestProductPeriodListQuery,
  useGetRequestProductPeriodCountQuery,
  useGetRequestProductPeriodInfiniteListInfiniteQuery,
} from '@api/listApi';

const tableStructure = {
  subdistributor: {
    head: 'Periode',
    body: 'year',
  },
  name: {
    head: 'Attachments',
    body: 'attachments',
    type: 'slot',
  },
  business_type: {
    head: 'Actions',
    body: 'actions',
    type: 'slot',
  },
};

// RTK cache is frozen — build a new row object (add id + default web cursor).
const mapRow = (item) => ({
  ...item,
  id: item._id,
  style: { cursor: 'default' },
});

function RequestProductPeriodScreen(props) {
  const [showAttachments, setShowAttachments] = useState(false);
  const [selectedPeriod, setSelectedPeriod] = useState(null);
  const [showAddEdit, setShowAddEdit] = useState(false);

  const hasAccessCreate = !hasNoAccess([
    'superadmin',
    'general',
    'general_manager_marketing',
  ]);

  const { list, count, openChild, scope, params } = useListScreen({
    listHook: useGetRequestProductPeriodListQuery,
    countHook: useGetRequestProductPeriodCountQuery,
    infiniteHook: useGetRequestProductPeriodInfiniteListInfiniteQuery,
  });

  const rows = useMemo(() => {
    const raw = isWeb
      ? Array.isArray(list.data)
        ? list.data
        : []
      : (list.data?.pages ?? []).flat();
    return raw.map(mapRow);
  }, [list.data]);

  const handleDetail = (data) => {
    setSelectedPeriod(null);
    openChild('RequestProductListingScreen', {
      titleScreen: `${data.year}`,
      name: `${data.year}`,
      year: `${data.year}`,
      go_back_key: props.route.key,
    });
  };

  const handleAddModal = () => {
    setShowAddEdit(true);
  };

  const handleEditModal = (data) => {
    setShowAddEdit(true);
    setSelectedPeriod(data);
  };

  const onSeeAttachment = (data) => {
    setShowAttachments(true);
    setSelectedPeriod(data);
  };

  const handleCloseAttachments = () => {
    setShowAttachments(false);
    setSelectedPeriod(null);
  };

  const handleCloseAddEdit = () => {
    setShowAddEdit(false);
    setSelectedPeriod(null);
  };

  const handleSubmitPeriod = async () => {
    setShowAddEdit(false);
    setSelectedPeriod(null);
    list.refetch();
  };

  useEffect(() => {
    try {
      const menus = [];
      if (hasAccessCreate) {
        menus.push({
          type: 'function',
          name: 'Add',
          callback: handleAddModal,
        });
      }
      props.navigation.setOptions({
        headerRight: () => {
          return isWeb ? (
            <NotificationSettingButton {...props} />
          ) : (
            <MoreButton menu={menus} {...props} />
          );
        },
      });
    } catch (error) {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.navigation]);

  return (
    <Layout.Container>
      {isWeb && (
        <Layout.Title title="Product Listing & Summary" style={{ zIndex: 9 }}>
          {hasAccessCreate ? (
            <View
              style={{
                display: 'flex',
                flexDirection: 'row',
              }}>
              <Button
                type="primary"
                rounded={true}
                buttonStyle={{ width: 90, marginRight: 10 }}
                title={
                  <SociollaText
                    type="medium"
                    style={{ fontSize: 14, color: Colors.white }}>
                    + Add
                  </SociollaText>
                }
                onPress={handleAddModal}
              />
            </View>
          ) : (
            false
          )}
        </Layout.Title>
      )}
      {isWeb ? (
        <Table
          name="request-product-period"
          filterName={scope}
          structures={tableStructure}
          loading={list.isLoading}
          refetching={list.isFetching}
          data={rows}
          showSearch={false}
          hasNoHide={true}
          totalData={count.data}
          skip={params.skip}
          limit={params.limit}
          showFilter={false}
          slot={{
            attachments: ({ data, index }) => (
              <>
                <RenderIf condition={data?.attachments?.length}>
                  <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                    <Image
                      style={{ width: 22, height: 22, marginRight: 6 }}
                      source={require('@/assets/img/icons/attachment.png')}
                      isResolveAsset
                    />
                    <TouchableOpacity onPress={() => onSeeAttachment(data)}>
                      <SociollaText style={{ color: Colors.blue0 }}>
                        See attachments
                      </SociollaText>
                    </TouchableOpacity>
                  </View>
                </RenderIf>
                <RenderIf condition={!data?.attachments?.length}>
                  <SociollaText>-</SociollaText>
                </RenderIf>
              </>
            ),
            actions: ({ data, index }) => (
              <View
                style={{
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-evenly',
                }}>
                <RenderIf condition={hasAccessCreate}>
                  <TouchableOpacity onPress={() => handleEditModal(data)}>
                    <Image
                      style={{ width: 16, height: 16 }}
                      svg={true}
                      source={require('@assets/img/icons/edit-grey.svg')}
                      isResolveAsset
                    />
                  </TouchableOpacity>
                </RenderIf>
                <TouchableOpacity onPress={() => handleDetail(data)}>
                  <Image
                    style={{ width: 24, height: 16 }}
                    source={require('@assets/img/icons/eye.png')}
                    isResolveAsset
                  />
                </TouchableOpacity>
              </View>
            ),
          }}
        />
      ) : (
        <TableMobile
          filterName={scope}
          loading={list.isLoading}
          refetching={list.isFetching}
          loadingLoadMore={list.isFetchingNextPage}
          hasNextPage={list.hasNextPage}
          onLoadMore={list.fetchNextPage}
          onRefresh={list.refetch}
          skip={params.skip}
          limit={params.limit}
          data={rows}
          totalData={count.data}
          showSearch={false}
          renderItem={({ data, index }) => (
            <TouchableOpacity
              activeOpacity={0.6}
              style={styles.item}
              onPress={() => onSeeAttachment(data)}
              key={index}>
              <View>
                <SociollaText>Periode:</SociollaText>
                <SociollaText type="bold" style={{ fontSize: 16 }}>
                  {data.year}
                </SociollaText>
              </View>
            </TouchableOpacity>
          )}
        />
      )}

      <ModalAttachment
        show={showAttachments}
        onClose={handleCloseAttachments}
        data={selectedPeriod}
        handleEditModal={handleEditModal}
        handleDetail={handleDetail}
        hasAccessCreate={hasAccessCreate}
      />

      <ModalAddEditPeriod
        show={showAddEdit}
        onClose={handleCloseAddEdit}
        data={selectedPeriod}
        isAdd={selectedPeriod === null}
        handleSubmitPeriod={handleSubmitPeriod}
      />
    </Layout.Container>
  );
}

const styles = StyleSheet.create({
  item: {
    width: '100%',
    paddingVertical: 20,
    paddingHorizontal: 20,
    backgroundColor: Colors.white,
    borderBottomWidth: 1,
    borderBottomColor: Colors.grey0,
  },
});

export default RequestProductPeriodScreen;
